import {useTranslation} from "react-i18next";

export const useProjectTranslations = () => {
  const {t} = useTranslation();

  const getTranslatedProject = projectIndex => {
    const projects = t("projects.list", {returnObjects: true});
    return projects[projectIndex] || {};
  };

  const getTranslatedFooterLink = linkName => {
    const translations = {
      "View on GitHub": t("projects.buttons.github"),
      "Download on Google Play": t("projects.buttons.googlePlay"),
      "Play Game": t("projects.buttons.playGame"),
      "Private Repository": t("projects.buttons.private"),
      "Watch Video": t("projects.buttons.watchVideo"),
      "View Game": t("projects.buttons.viewGame"),
      "Download Game": t("projects.buttons.downloadGame"),
      Certification: t("projects.buttons.certification")
    };
    return translations[linkName] || linkName;
  };

  return {
    getTranslatedProject,
    getTranslatedFooterLink
  };
};
